// src/subscreens/admin/restockMaterial/RestockMaterial.jsx
//
// CHANGED: No longer uses useInventory() context.
// Receives full `material` object and `onAddStock` callback via props.

import React, { useContext, useState } from "react";
import Modal from "../../../components/admin/modal/ProductModel";
import { Package } from "lucide-react";
import "../../../assets/css/admin/restockMaterial/RestockMaterial.css";
import axios from "axios";
import context from "react-bootstrap/esm/AccordionContext";
import AppContext from "../../../context/AppContext";

const RestockMaterial = ({ isOpen, onClose, material, onAddStock }) => {
  const {baseUrl, authToken} = useContext(AppContext);
  const [quantity, setQuantity] = useState("");
  // const [reason, setReason] = useState("Stock Reorder");
  const [errors, setErrors] = useState({});
  const [isAdding, setIsAdding] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [idToUpdate, setIdToUpdate] = useState("");

  console.log("show sucess:", showSuccess);
  const restockInventory = () => {
    console.log("restock inventory called!");
    const formData = new FormData();
    formData.append("admaterial_id", material.id);
    formData.append("quantity", quantity);
    // formData.append("reason", reason);
    axios.post(`${baseUrl}/admin/inventory/restockInventory`, formData, {
      headers: {
        Authorization: `Bearer${authToken}`
      }
    }).then((response) => {
      console.log(response.data);
      if(response.data.success){
        console.log("success state true");
        onAddStock(Number(quantity));
        alert("stock updated successfully!");
        setQuantity("");
        setIsAdding(false);
        onClose();
      }else{
        alert("failed to update stock");
         setIsAdding(false);
      }
    }).catch((error) => {
      console.log(error);
       setIsAdding(false);
    })
  }

  const validate = () => {
    const errs = {};
    if (!quantity || Number(quantity) <= 0)
      errs.quantity = "Valid quantity is required";
    // if (!reason.trim()) errs.reason = "Reason is required";
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    setIsAdding(true);
    restockInventory();
  };

  // Guard: if no material passed, don't render
  if (!material) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Restock Material"
      size="small"
    >
      {showSuccess ? (
        <div className="inv-restock-success">
          <div className="inv-restock-success-icon">✓</div>
          <h3>Stock Added Successfully!</h3>
          <p>Material stock has been updated.</p>
        </div>
      ) : (
        <form className="inv-restock-form" onSubmit={handleSubmit}>
          {/* Material Info */}
          <div className="inv-restock-info">
            <Package size={40} className="inv-restock-icon" />
            <div className="inv-restock-details">
              <h4>{material.name}</h4>
              <p>
                Current Stock:{" "}
                <strong>
                  {material.currentStock} {material.unit}
                </strong>
              </p>
              <p>
                Minimum Stock:{" "}
                <strong>
                  {material.minimumStock} {material.unit}
                </strong>
              </p>
            </div>
          </div>

          {/* Quantity */}
          <div className="inv-restock-group">
            <label htmlFor="quantity">Quantity to Add *</label>
            <input
              type="number"
              id="quantity"
              value={quantity}
              onChange={(e) => {
                setQuantity(e.target.value);
                if (errors.quantity) setErrors((p) => ({ ...p, quantity: "" }));
              }}
              className={errors.quantity ? "inv-restock-error" : ""}
              placeholder={`Enter quantity in ${material.unit}`}
              min="1"
            />
            {errors.quantity && (
              <span className="inv-restock-error-text">{errors.quantity}</span>
            )}
          </div>

          {/* Reason */}
          {/* <div className="inv-restock-group">
            <label htmlFor="reason">Reason *</label>
            <input
              type="text"
              id="reason"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (errors.reason) setErrors((p) => ({ ...p, reason: "" }));
              }}
              className={errors.reason ? "inv-restock-error" : ""}
              placeholder="e.g., Stock Reorder"
            />
            {errors.reason && (
              <span className="inv-restock-error-text">{errors.reason}</span>
            )}
          </div> */}

          {/* New stock preview */}
          <div className="inv-restock-preview">
            <p>
              New Stock will be:{" "}
              <strong>
                {material.currentStock + Number(quantity || 0)} {material.unit}
              </strong>
            </p>
          </div>

          <div className="inv-restock-actions">
            <button
              type="button"
              className="inv-restock-cancel"
              onClick={onClose}
              disabled={isAdding}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="inv-restock-save"
              disabled={isAdding}
            >
              {isAdding ? "Adding Stock..." : "Add Stock"}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default RestockMaterial;
